/* eslint-disable react/require-default-props */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import {
  useEffect,
  useRef,
  useState,
  useCallback,
  CSSProperties,
  forwardRef,
  useImperativeHandle,
  ForwardedRef,
  TextareaHTMLAttributes,
} from 'react';

import { useField } from '@unform/core';
import { IconBaseProps } from 'react-icons';
import { FiAlertCircle } from 'react-icons/fi';

import * as S from './styles';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  name: string;
  label?: string;
  customDescriptionCount?: string;
  containerStyle?: CSSProperties;
  labelStyle?: CSSProperties;
  icon?: React.ComponentType<IconBaseProps>;
  showIconPassword?: boolean;
}

const Textarea = forwardRef(
  (
    {
      name,
      containerStyle = {},
      customDescriptionCount,
      labelStyle,
      label,
      icon: Icon,
      showIconPassword = false,
      ...rest
    }: TextareaProps,
    innerRef?: ForwardedRef<HTMLTextAreaElement>,
  ) => {
    const inputRef = useRef<HTMLTextAreaElement>(null); // HTMLInputElement - vai dar ao inputRef as propriedades de um input

    const [isFocused, setIsFocused] = useState(false); // Se esta com foco
    const [isFilled, setIsFilled] = useState(false); // Se esta preenchido

    useImperativeHandle<HTMLTextAreaElement | null, HTMLTextAreaElement | null>(
      innerRef,
      () => inputRef.current,
      [],
    );

    const { fieldName, defaultValue, error, registerField } = useField(name);

    const handleInputFocus = useCallback(() => {
      setIsFocused(true);
    }, []);

    const handleInputBlur = useCallback(() => {
      setIsFocused(false);

      // Verifica se o inputRef tem um valor/value. Se tiver preenchido = true. Se tiver vazio = false. !! Tranforma o value em booleano.
      setIsFilled(!!inputRef.current?.value); // inputRef pega o valor direto do Input. document.querySelector('input') e etc.
    }, []);

    useEffect(() => {
      registerField({
        name: fieldName,
        ref: inputRef.current,
        path: 'value',
      });
    }, [fieldName, registerField]);

    return (
      <S.InputBlock style={containerStyle}>
        {label && (
          <S.Label style={labelStyle} htmlFor={name}>
            {label}

            {customDescriptionCount && (
              <p>{customDescriptionCount?.length} / 1000</p>
            )}
          </S.Label>
        )}
        <S.Container
          isErrored={!!error}
          isFilled={isFilled}
          isFocused={isFocused}
        >
          <textarea
            onFocus={handleInputFocus} // Receber o foco
            onBlur={handleInputBlur} // Perder o foco
            defaultValue={defaultValue}
            ref={inputRef}
            {...rest}
          />

          {Icon && <Icon size={18} />}

          {error && !showIconPassword && (
            <S.Error title={error}>
              <FiAlertCircle color="#c53030" size={20} />
            </S.Error>
          )}
        </S.Container>
      </S.InputBlock>
    );
  },
);

Textarea.defaultProps = {
  label: '',
  containerStyle: {},
  labelStyle: {},
  icon: undefined,
  showIconPassword: false,
};

export default Textarea;
